import React, { createContext, useContext, useState, useCallback } from 'react';
import Toast from '../components/common/Toast';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);

  const mostrar = useCallback((mensaje, tipo = 'success') => {
    setToast({ mensaje, tipo });
  }, []);

  const cerrar = useCallback(() => setToast(null), []);

  return (
    <ToastContext.Provider value={{ mostrar }}>
      {children}
      {toast && (
        <Toast
          mensaje={toast.mensaje}
          tipo={toast.tipo}
          onCerrar={cerrar}
        />
      )}
    </ToastContext.Provider>
  );
}

export const useToast = () => useContext(ToastContext);